<template>
    <app-page-options-list 
        :options="options"
    />            
</template>
<script>
    import PageOptionsList from '../../components/UI/Controls/PageOptions/PageOptionsList.vue';
    export default {
        components: {
            appPageOptionsList: PageOptionsList
        },
        data(){
            return {
                options: [
                    { to: 'personVisitors', label: 'Visitas de Personas', icon: '' },
                    { to: 'vehicleVisitors', label: 'Visitas de Vehículos', icon: '' },
                    { to: 'PqrPage', label: 'PQR', icon: ''},
                    { to: 'dutiesAdminClientPage', label: 'Consignas', icon: ''},
                    { to: 'notebookAdminClient', label: 'Minutas', icon: ''},
                    { to: 'listStructuresAdminClient', label: 'Estructuras', icon: ''},
                    { to: 'authorizeEntryPersonListAdminClient', label: 'Autorizaciones', icon: ''},
                    { to: 'reportingDashboard', label: 'Reportes', icon: ''},
                    { to: 'peoplePageListClient', label: 'Personas', icon: ''},
                    { to: 'vehiclesPageClient', label: 'Vehículos', icon: ''},
                    
                ]
            }
        }
    }
</script>